<template>
  <div
    class="modal fade"
    id="newPlanSubscriptionModal"
    ref="subscriptionModal"
    style="z-index: 2000"
    tabindex="2"
    role="dialog"
    aria-labelledby="newPlanSubscriptionModalLabel"
    data-backdrop="static"
  >
    <div 
      class="modal-dialog"
      role="document"
    >
      <!--  ------------------------------- Show plan expired ----------------------------------------- -->
      <div 
        v-if="
          $parent.typeNewPlan == 'Expired' ||
            $parent.typeNewPlan == 'NotAccess'
        "
        class="modal-content"
      >
        <div :class="['modal-header', $parent.typeNewPlan == 'Expired' ? 'bg-danger' : 'bg-warning']">
          <h5 class="modal-title">
            <span v-if="$parent.typeNewPlan == 'Expired'">
              <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Subscription Expired") }}
            </span>
            <span v-else-if="$parent.typeNewPlan == 'NotAccess'">
              <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Access Not Available") }}
            </span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="showModalDisableUpsell()"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div 
            v-if="$parent.typeNewPlan == 'Expired'"
            class=" text-center"
          >
            <div>
              <img 
                :src="$storeIndex.getImageSrc('banner-subscription-expired')"
                class="mb-3 img-fluid"
                style="width:110px;"
              >
            </div>
            <div class="h4">
              {{ $t("Subscription Expired") }}!
            </div>
            <div>
              {{ $t("Your package has expired. If you want to continue using it,") }}
              <br>
              {{ $t("please press 'Upgrade Now'. If you feel this is a mistake, contact your admin.") }}
            </div>
          </div>
          <div 
            v-else-if="$parent.typeNewPlan == 'NotAccess'"
            class=" text-center"
          >
            <div>
              <img 
                :src="$storeIndex.getImageSrc('banner-access-not-available')"
                class="mb-3 img-fluid"
                style="width:189px;"
              >
            </div>
            <div class="h4">
              {{ $t("Access Not Available") }} !
            </div>
            <div>
              {{ $t("Current plan is not support this feature.") }}
              <br>
              {{ $t("Please subscribe upper plan to access the feature.") }}
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            :class="['btn mr-3', $parent.typeNewPlan == 'Expired' ? 'btn-outline-danger' : 'btn-outline-warning']"
            data-dismiss="modal"
            @click="showModalDisableUpsell()"
          >
            <i class="fa-regular fa-thumbs-up fa-1x mr-1" /> {{ $t('OK') }}
          </button>
          <button
            type="button"
            :class="['btn', $parent.typeNewPlan == 'Expired' ? 'btn-danger' : 'btn-warning']"
            data-dismiss="modal"
            @click="redirectTo()"
          >
            <i class="fa-solid fa-envelope-open-dollar fa-1x mr-1" /> {{ $t('Upgrade Now') }}!
          </button>
        </div>
      </div>
      <!--  ---------------------------------- Show Congratulation new plan -------------------------------------- -->
      <div
        v-else
        class="modal-content"
      >
        <div class="modal-body text-center">
          <div class="m-1">
            <div class="mb-3">
              <img
                src="@/assets/global_assets/images/subscription_upgraded.png"
                class="img-fluid"
              >
            </div>
            <h1 class="error-page-title">
              {{ $t("Congratulation") + "!" }}
            </h1>
            <div 
              class="error-page-text mb-3"
              style="font-size: 14px;"
            >
              <div>
                {{ $t("Your store has upgraded subscription.") }}
              </div>
            </div>
            <div>
              <button
                class="btn btn-lg btn-primary"
                data-dismiss="modal"
                aria-label="Close"
                @click="okCongrate()"
              >
                <i class="fa-solid fa-thumbs-up fa-1x mr-1" /> {{ $t("OK") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalNewPlanSubscription",
  data() {
    return {
      redirect: "https://gosell.tech/price",
    };
  },
  mounted() {
    $(this.$refs.subscriptionModal).on("hidden.bs.modal", () => {
      this.$parent.showNewPlan = false;
      // this.$store.dispatch("user/showPlanNoti", false);
    });
  },
  methods: {
    redirectTo() {
      // window.open(this.redirect, "_blank");
      try {
        this.$nextTick( () => {
          this.$router.push({ name: "t.a.premium.subscriptions.select"});
        });   
      } catch (err) {
        console.log(err);
      }
    },
    showModalDisableUpsell() {
      this.$parent.showNewPlan = false;
      this.$parent.showPlanNoti = false;
      this.$parent.showPopUp();
    },
    okCongrate(){
      this.$parent.showNewPlan = false;
      this.$parent.showPlanNoti = false;
      this.$parent.showPopUp();
      this.$store.dispatch("user/showPlanNoti", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalNewPlanSubscription.vue